// Shared ft/in dropdown options + styling for the Height field.
// Used by the Add/Edit Client form (client-entry.tsx) and the in-place
// "Client Information" editor (bloodwork-test-analysis.tsx) so both render
// the exact same dropdowns.

export type HeightOption = { value: string; label: string };

export const FT_OPTIONS: HeightOption[] = [
  { value: '', label: '—' },
  ...[1, 2, 3, 4, 5, 6, 7, 8].map(n => ({ value: String(n), label: String(n) })),
];

export const IN_OPTIONS: HeightOption[] = [
  { value: '', label: '—' },
  ...[0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11].map(n => ({ value: String(n), label: String(n) })),
];

export const HEIGHT_SELECT_STYLES = {
  control: (base: any) => ({
    ...base,
    minHeight: '31px',
    height: '31px',
    borderColor: '#ced4da',
    boxShadow: 'none',
    fontSize: '12px',
    '&:hover': { borderColor: '#80bdff' },
  }),
  valueContainer: (base: any) => ({ ...base, padding: '0 6px', height: '31px' }),
  input: (base: any) => ({ ...base, margin: '0', padding: '0' }),
  indicatorsContainer: (base: any) => ({ ...base, height: '31px' }),
  dropdownIndicator: (base: any) => ({ ...base, padding: '4px' }),
  menu: (base: any) => ({ ...base, zIndex: 9999, width: 'auto', minWidth: '100%' }),
  option: (base: any) => ({ ...base, fontSize: '12px', padding: '4px 8px' }),
  singleValue: (base: any) => ({ ...base, fontSize: '12px' }),
};
